<template>
<div class="hotel-modal text-center">
    <v-progress-circular v-if="loading_hotel" :size="70" :width="7" color="primary" indeterminate></v-progress-circular>
    <v-card v-else flat :class="{'pa-1': $vuetify.breakpoint.smAndDown}">
        <v-row class="pa-2" align="center">
            <v-col cols="9" md="5">
                <div class="important font-weight-bold">{{ item.name }}</div>
                <v-rating v-model="item.stars" full-icon='favorite' empty-icon='favorite_border' color="red" :readonly="true" background-color="red"></v-rating>
                <div v-if="item.test" class="important red--text text-center">Test</div>
            </v-col>
            <v-col cols="3" md="2">
                <div class="text-center">
                    <div class="regular font-weight-bold">{{ item.console_id }}</div>
                    <div v-if="item.status" class="regular">{{ getStatus(item.status) }}</div>
                    <div v-if="item.context" class="regular">{{ getContext(item.context) }}</div>
                </div>
            </v-col>
            <v-col md="5" v-if="$vuetify.breakpoint.mdAndUp">
                <div class="text-center">
                    <div>
                        {{ item.city }} <span v-if="item.region">, {{ item.region }}</span>
                    </div>
                    <div>{{ item.address }}</div>
                    <div>{{ item.contact.phone }}</div>
                    <div>{{ item.contact.email }}</div>
                </div>
            </v-col>
        </v-row>

        <v-divider v-if="$vuetify.breakpoint.mdAndUp" class="mx-2" />

        <div class="pa-2" v-if="$vuetify.breakpoint.mdAndUp">
            <div class="d-flex" style="overflow-x: auto; white-space:nowrap; width: 100%">
                <img v-for="(image, index) in item.media" :src="image" contain height="64" :key="'img' + index" class="ma-1">
            </div>
        </div>

        <v-divider v-if="$vuetify.breakpoint.mdAndUp && item.media" class="mx-2" />

        <div v-if="item.description" style="position: relative;margin-bottom: 20px;text-align: left;" class="pa-2 mx-2">
            <div :class="{'description':true,'more':show_more}">
                {{ item.description.ro }}
            </div>
            <v-btn color="primary" small text absolute right @click="show_more = !show_more">
                <span v-if="!show_more">Show more</span>
                <span v-else>Show less</span>
            </v-btn>
        </div>

        <v-divider v-if="$vuetify.breakpoint.mdAndUp && item.description" class="mx-2" />

        <v-row>
            <v-col cols="12" md="6" order-md="2">
                <div class="">
                    <div class="text-center" v-for="room in item.rooms" :key="room.id">
                        <div class="regular font-weight-bold">{{ room.name }}</div>
                        <div class="detail">{{ room.max_adults }} adulti + {{ room.max_children }} copil</div>
                    </div>
                </div>
            </v-col>
            <v-col cols="12" md="6">
                <div>
                    <v-row align="center">
                        <v-col cols="8" class="important font-weight-bold">
                            Clasification number
                        </v-col>
                        <v-col cols="4" class="regular text-left">
                            <span v-if="item.classification_number">{{ item.classification_number }}</span>
                            <span v-else>N/A</span>
                        </v-col>
                    </v-row>
                    <v-row align="center">
                        <v-col cols="8" class="important font-weight-bold">
                            Last Available Date
                        </v-col>
                        <v-col cols="4" class="regular text-left">
                            <span v-if="item.stats.last_available_date">{{ formatDate(item.stats.last_available_date) }}</span>
                            <span v-else>N/A</span>
                        </v-col>
                    </v-row>
                </div>
            </v-col>
            <v-divider v-if="$vuetify.breakpoint.smAndDown" class="mx-2"></v-divider>

        </v-row>
        <v-divider v-if="$vuetify.breakpoint.mdAndUp" />
        <!-- reservation chips days -->
        <div class="ma-1 im-find d-flex align-center">
            <v-btn class="ma-1" v-for="(date, index) in days" :key="index" small rounded depressed :color="date.selected ? 'primary' : 'grey lighten-2'" :text-color="date.selected ? 'white' : 'grey'" @click="selectReservation(index,date)">
                <span class="text-capitalize caption">{{date.text}}</span>
            </v-btn>
        </div>

        <div style="position: relative; height: 3px">
            <v-progress-linear v-if="loading" indeterminate height="3" class="pa-0 ma-0" color="primary" style="position: absolute" />
        </div>
        <!-- ./ reservation chips days -->

        <!-- DATATABLE ROWS  reservation-->
        <v-card tile flat>
            <!-- <v-data-iterator :items="reservations" :pagination.sync="pagination" :total-items="total" :rows-per-page-items="rppi"> -->
            <v-data-iterator :items="reservations" :page.sync="page" :items-per-page.sync="size" :server-items-length="total" :footer-props="{ itemsPerPageOptions }">
                <template slot="item" slot-scope="props">
                    <im-reservation-item :item="props.item"></im-reservation-item>
                </template>
                <template slot="no-data">
                    <v-alert :value="true" class="mx-1" type="info" color="primary">
                        No data available.
                    </v-alert>
                </template>
            </v-data-iterator>
        </v-card>
        <!-- ./ DATATABLE ROWS  reservation-->
    </v-card>
</div>
</template>

<script>
import IMReservationItem from './ReservationCard.vue';
import IMPeriod from '../small-components/IMPeriod.vue';
import IMPrice from '../small-components/IMPrice.vue';

export default {
    components: {
        'im-period': IMPeriod,
        'im-price': IMPrice,
        'im-reservation-item': IMReservationItem,
    },
    data() {
        return {
            loading_hotel: false,
            show_more: false,
            reservation_from: 'today',
            reservations: [],
            // table attributes
            loading: null,
            total: 0,
            page: 1,
            size: 5,
            itemsPerPageOptions: [5, 10, 15, 25],

            // date filters
            timestamp_after: null,
            timestamp_before: null,
            check_in_after: null,
            check_in_before: null,
            check_out_after: null,
            check_out_before: null,
            item: {
                contact: {
                    phone: null,
                    email: null,
                },
                description: {
                    ro: null,
                    en: null
                },
                media: [],
                rooms: [],
                stats: {
                    last_available_date: null
                }
            },
            days: [
                {
                    text: 'Rezervari din Trecut',
                    value: 'past',
                    color_b: false
                    }, {
                    text: 'Rezervari Azi',
                    value: 'today',
                    selected: true,
                    }, {
                    text: 'Rezervari Viitoare',
                    value: 'future',
                    selected: false
                    }
                ],
        }
    },

    props: {
        item_id: {
            type: Number,
            default: 2
        }
    },
    watch: {
        item_id: {
            handler() {
                this.reservations = [];
                this.getItem();
                this.getReservations();
            }
        },
        page: {
            handler() {
                this.getReservations();
            }
        },
        size: {
            handler() {
                this.getReservations();
            }
        },

    },
    created() {
        this.reservations = [];
        this.getItem();
    },

    methods: {
        getItem() {
            if(!this.item_id) {
                return
            }

            // clear to defaults data
            this.reservation_from = 'today';
            this.days.forEach((elem, index) => {
                if(elem.value === 'today') {
                    this.days[index].selected = true;
                } else {
                    this.days[index].selected = false;
                }
            });

            // we are currently loading
            this.loading_hotel = true;

            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === 'true' ? 'https://' : 'http://';
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + '/api/services-new/admin/hotels/' + this.item_id;

            this.$axios.get(endpoint)
                .then(response => {
                    this.item = response.data;
                })
                .catch(error => {
                    console.log(error);
                })
                .finally(() => {
                    this.loading_hotel = false;
                })
        },

        getReservations() {
            // we are currently loading
            this.loading = true;

            //prepare ordering params
            let order = null;
            let sortType = null;

            // prepare stamp & save current_stamp
            let stamp = Date.now();
            this.current_stamp = stamp;

            // set params for days
            switch (this.reservation_from) {
            case 'today':
                this.page = 1;
                this.check_in_after = null;
                this.check_in_before = this.$moment(stamp)
                    .format('YYYY-MM-DD');
                this.check_out_after = this.$moment(stamp)
                    .format('YYYY-MM-DD');
                this.check_out_before = null;
                order = ['timestamp'];
                sortType = ["desc"];
                break;
            case 'past':
                this.page = 1;
                this.check_in_after = null;
                this.check_in_before = null;
                this.check_out_after = null;
                this.check_out_before = this.$moment(stamp)
                    .format('YYYY-MM-DD');
                order = ['check_out'];
                sortType = ["desc"];
                break;
            case 'future':
                this.page = 1;
                this.check_in_after = this.$moment(stamp)
                    .format('YYYY-MM-DD');
                this.check_in_before = null;
                this.check_out_after = null;
                this.check_out_before = null;
                order = ['check_in'];
                sortType = ["asc"];
                break;
            }

            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === "true" ? "https://" : "http://";
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + "/api/services-new/admin/reservations";

            // setup query params
            let params = {
                params: {
                    size: this.size,
                    page: this.page,
                    order: order,
                    dir: sortType,
                    stamp: stamp,
                    // operational fields
                    hotel_id: this.item_id,
                    check_in_after: this.check_in_after,
                    check_in_before: this.check_in_before,
                    check_out_after: this.check_out_after,
                    check_out_before: this.check_out_before
                }
            };

            this.$axios.get(endpoint, params)
                .then(response => {
                    if(parseInt(this.current_stamp) === parseInt(response.data.meta.stamp)) {
                        this.reservations = response.data.data;
                        this.total = response.data.pagination.total;
                    }
                })
                .catch(error => {
                    console.log(error);
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        formatDate(value) {
            if(!value) return value;
            let date = value * 1000;
            return this.$moment(date)
                .format('D MMM YY');
        },

        selectReservation(index_date, date) {
            this.days.forEach((num, index) => {
                if(index_date === index) {
                    this.days[index].selected = true;
                } else {
                    this.days[index].selected = false;
                }
            });
            this.reservation_from = date.value;
            this.getReservations();

        },

        getStatus(value) {
            switch (value) {
            case 'registred':
                return 'Inregistrat';
            case 'accepted':
                return 'Accepted';
            case 'suspended':
                return 'Suspendat';
            case 'published':
                return 'Publicat';
            case 'refused_by_us':
                return 'Refuzat de noi';
            case 'refused_by_them':
                return 'Refuzat de ei';
            }
        },
        getContext(value) {
            switch (value) {
            case 'imemento':
                return 'iMemento';
            case 'yieldplanet':
                return 'YieldPlanet';
            case 'pynbooking':
                return 'PynBooking';
            }
        },

        emitClick() {
            this.$emit('click');
        },

    },

}
</script>

<style>
.description {
    padding-bottom: 15px;
    line-height: 15px;
    height: 47px;
    overflow: hidden;
}

.description.more {
    height: auto;
}

@media only screen and (max-width: 600px) {
    .hotel-modal .im-find {
        overflow-x: scroll;
        white-space: nowrap;
        width: 100%;
    }
}
</style>
